(() => {
	openTable();

	function openTable () {
		let countryHandle= getCookie("customerCountryCodeUd");
		if (!countryHandle) {
			document.addEventListener("initCountryData", () => {
				openTable();
			});

			return null;
		}

		if (!document.querySelector(`[data-country-trigger="${countryHandle}"]`)) {
			countryHandle = "US"
		}

		const trigger = document.querySelector(`[data-country-trigger="${countryHandle}"]`);
		const tableContent = document.querySelector(`[data-country-target="${countryHandle}"]`);
		const tableDescription = document.querySelector(`[data-country-description="${countryHandle}"]`);
		const table = document.querySelector(".js-country-table")
		const select = document.querySelector(".js-shipping-countries-select");
		const selectTrigger = document.querySelector(".js-shipping-countries-select-trigger");
		const option = select.querySelector(`[data-value="${countryHandle}"]`);

		const selectYPosition = select.offsetTop;

		if (!trigger || !tableContent || !tableDescription) {
			return null
		}

		trigger.classList.add("active");

		if (tableContent) {
			table.classList.add("active");
			tableContent.classList.add("active");
		}

		if (tableDescription) {
			tableDescription.classList.add("active");
		}

		selectTrigger.innerHTML = option.innerHTML;

		if (window.innerWidth <= 768) {
			window.scrollTo({
				top: selectYPosition,
				left: 0,
				behavior: 'smooth'
			});
		}
	}

	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}
})();
